import React from 'react';
import ScrollReveal from './ScrollReveal'; // <--- Importando a mágica

export default function Infrastructure() {
  return (
    <section className="py-20 bg-conectiva-navy relative overflow-hidden">
      
      <div className="absolute top-0 right-0 -mr-20 -mt-20 w-96 h-96 bg-conectiva-lime opacity-5 rounded-full blur-3xl"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        
        {/* Animação do Texto */}
        <ScrollReveal>
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
              Aprenda na <span className="text-conectiva-lime">prática</span>
            </h2>
            <p className="text-gray-400 max-w-2xl mx-auto">
              Vivencie a rotina hospitalar desde o primeiro dia em ambientes de alta tecnologia.
            </p>
          </div>
        </ScrollReveal>

        {/* BENTO GRID COM ANIMAÇÃO EM CASCATA */}
        <div className="grid grid-cols-1 md:grid-cols-4 md:grid-rows-2 gap-4 h-auto md:h-[600px]">
          
          {/* Foto Principal (Delay 0.2s) */}
          <div className="md:col-span-2 md:row-span-2">
            <ScrollReveal delay={0.2}>
              <div className="relative group overflow-hidden rounded-2xl border-2 border-white/5 transition-all duration-300 hover:border-conectiva-lime hover:shadow-[0_0_30px_rgba(204,255,0,0.15)] h-full">
                <img 
                  src="https://somosconexaosocial.org/connectiva-img/2.jpg" 
                  alt="Laboratório Principal" 
                  className="w-full h-64 md:h-full object-cover transition duration-700 group-hover:scale-110 opacity-90 group-hover:opacity-100"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-conectiva-navy via-transparent to-transparent flex items-end p-6">
                  <div>
                    <span className="inline-block px-2 py-1 bg-conectiva-lime text-conectiva-navy text-xs font-bold rounded mb-2">
                      ALTA TECNOLOGIA
                    </span>
                    <span className="block text-white font-bold text-xl group-hover:text-conectiva-lime transition-colors duration-300">
                      Laboratórios de Simulação
                    </span>
                  </div>
                </div>
              </div>
            </ScrollReveal>
          </div>

          {/* Foto 2 (Delay 0.4s) */}
          <div className="md:col-span-2">
             <ScrollReveal delay={0.4}>
              <div className="relative group overflow-hidden rounded-2xl border-2 border-white/5 transition-all duration-300 hover:border-conectiva-lime hover:shadow-[0_0_20px_rgba(204,255,0,0.15)] h-full">
                <img 
                  src="https://images.unsplash.com/photo-1581056771107-24ca5f033842?auto=format&fit=crop&q=80" 
                  alt="Aula Prática" 
                  className="w-full h-64 md:h-full object-cover transition duration-700 group-hover:scale-110 opacity-90 group-hover:opacity-100"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-conectiva-navy via-transparent to-transparent flex items-end p-4">
                  <span className="text-white font-semibold group-hover:text-conectiva-lime transition-colors duration-300">
                    Equipamentos Reais
                  </span>
                </div>
              </div>
            </ScrollReveal>
          </div>

          {/* Foto 3 (Delay 0.6s) */}
          <div>
            <ScrollReveal delay={0.6}>
              <div className="relative group overflow-hidden rounded-2xl border-2 border-white/5 transition-all duration-300 hover:border-conectiva-lime hover:shadow-[0_0_20px_rgba(204,255,0,0.15)] h-full">
                <img 
                  src="https://images.unsplash.com/photo-1519494026892-80bbd2d6fd0d?auto=format&fit=crop&q=80" 
                  alt="Biblioteca" 
                  className="w-full h-64 md:h-full object-cover transition duration-700 group-hover:scale-110 opacity-90 group-hover:opacity-100"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-conectiva-navy via-transparent to-transparent flex items-end p-4">
                  <span className="text-white font-semibold group-hover:text-conectiva-lime transition-colors duration-300">
                    Acervo Digital
                  </span>
                </div>
              </div>
            </ScrollReveal>
          </div>

          {/* Foto 4 (Delay 0.8s) */}
          <div>
            <ScrollReveal delay={0.8}>
              <div className="relative group overflow-hidden rounded-2xl border-2 border-white/5 transition-all duration-300 hover:border-conectiva-lime hover:shadow-[0_0_20px_rgba(204,255,0,0.15)] h-full">
                <img 
                  src="https://images.unsplash.com/photo-1576091160399-112ba8d25d1d?auto=format&fit=crop&q=80" 
                  alt="Área de Convivência" 
                  className="w-full h-64 md:h-full object-cover transition duration-700 group-hover:scale-110 opacity-90 group-hover:opacity-100"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-conectiva-navy via-transparent to-transparent flex items-end p-4">
                  <span className="text-white font-semibold group-hover:text-conectiva-lime transition-colors duration-300">
                    Área de Convivência
                  </span>
                </div>
              </div>
            </ScrollReveal>
          </div>

        </div>
      </div>
    </section>
  );
}